import React from 'react'

export default function CrmSources() {
  return (
    <>
      <option value="">How did you hear about us</option>
      <option value="11">Referred by a Friend</option>
      <option value="5">1310 The Ticket</option>
      <option value="75">106.1 KISS FM</option>
      <option value="38">105.3 The Fan</option>
      <option value="76">TV/Streaming</option>
      <option value="20">Google</option>
      <option value="51">Facebook</option>
      <option value="2004">KILT John Lopez</option>
      <option value="2025">Fox4 News</option>
      <option value="2002">Email</option>
      <option value="82">Instagram</option>
      {/* <option value="83">YouTube</option> */}
      <option value="361">BAM TV</option>
      <option value="356">NBC</option>
      <option value="10">Dallas Morning News</option>
      <option value="2029">TCU Football</option>
      <option value="2024">96.3 KSCS - Hawkeye</option>
      <option value="50">97.1 – The Eagle</option>
      <option value="40">820 WBAP - Carla Marion</option>
      <option value="52">KTRH - Jimmy Barrett</option>
      <option value="2009">KRBE – Producer Eric</option>
      <option value="206">790 KBME - Sean Salisbury</option>
    </>
  );
}